
let DEPLOYMENT_ENVIRONMENT_CONFIG: any = {
    "DEFAULT": {
        "BACKEND_BASE_API_URL": "https://apis.homeindex.ie",
        "POSTHOG_TOKEN": "phc_nkcEnXa4ZzTR8FYWyJrFh8KUrewHT6AUHTHmBd3MwWfM",
        "POSTHOG_HOST": "https://eu.i.posthog.com",
        "LOGIN_DETAILS": {
            "CLIENT_ID": "6fvj972i784knpqcju16gs0uho",
            "REDIRECT_URI": "https://www.homeindex.ie/",
            "HOME_URI": "https://www.homeindex.ie",
        },
        "IS_HTTPS": true
    },
    "DEV": {
        "BACKEND_BASE_API_URL": "http://localhost:5000",
        "LOGIN_DETAILS": {
            "CLIENT_ID": "6fvj972i784knpqcju16gs0uho",
            "REDIRECT_URI": "http://localhost:3000/",
            "HOME_URI": "http://localhost:3000/",
        },
        "IS_HTTPS": false
    },
    "PREPROD": {
        "BACKEND_BASE_API_URL": "https://apis.homeindex.ie",
        "LOGIN_DETAILS": {
            "CLIENT_ID": "6fvj972i784knpqcju16gs0uho",
            "REDIRECT_URI": "http://localhost:3000/",
            "HOME_URI": "http://localhost:3000/",
        },
        "IS_HTTPS": false
    },
    "PROD": {
    }
}

export default DEPLOYMENT_ENVIRONMENT_CONFIG
